<app-alerts></app-alerts>


<div  *ngIf="!loading; else load" class="row">
	<div class="col-12">
 
           <nb-card>
           <nb-card-header style="border-bottom:0 !important;">
                Статистика
           </nb-card-header>
           	<nb-card-body style="
    margin: 0px !important;
    padding: 0px !important;
">


			 
 			 <table class="table  table-hover" *ngIf="statItems">

		<thead >
		<tr><td>Назва</td><td>Перегляди</td><td class="hidden-mob">Унікальні</td> <td></td>   </tr>
		</thead>
		<tbody >
		<tr *ngFor="let stream of statItems">
			<td>{{stream.title}}</td>
			<td>{{stream.stat?.visitors || 0}}</td>
			 <td  class="hidden-mob">{{stream.stat?.uniqueVisitors || 0}}</td>
			<td><a *ngIf="stream.stat" [routerLink]="['/statistics', stream._id]">Детальніше</a></td>
				 
		</tr>

		</tbody>
		</table>
		  
        	</nb-card-body>
           </nb-card> 
      
	</div>

</div>


<ng-template #load>
    <app-skeleton-page [height]="'900px'" [type]="'table'" ></app-skeleton-page>

   <!-- <div style="position: absolute; z-index: 777; width:100%; height:100%; top:0; left: 0; display: flex; align-self: center;">
    <div style="margin: auto;"> 
         <app-loader></app-loader>
     </div>
    </div> -->
</ng-template> 

